import { render, staticRenderFns } from "./EndpointModal.vue?vue&type=template&id=628837b2&scoped=true"
import script from "./EndpointModal.vue?vue&type=script&lang=js"
export * from "./EndpointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628837b2",
  null
  
)

export default component.exports